import React from 'react';
import { BarChart3, TrendingUp, BookOpen } from 'lucide-react';
export type Page = 'scorecard' | 'career' | 'points';
interface PageNavProps {
  page: Page;
  onChange: (page: Page) => void;
}
export function PageNav({
  page,
  onChange
}: PageNavProps) {
  const tabs: {
    id: Page;
    label: string;
    icon: React.ReactNode;
  }[] = [{
    id: 'scorecard',
    label: 'Scorecard',
    icon: <BarChart3 className="w-4 h-4" data-id="element-442" />
  }, {
    id: 'career',
    label: 'Career Progression',
    icon: <TrendingUp className="w-4 h-4" data-id="element-443" />
  }, {
    id: 'points',
    label: 'Point System',
    icon: <BookOpen className="w-4 h-4" data-id="element-444" />
  }];
  return <nav className="bg-white border-b border-gray-200 px-4 sm:px-6" aria-label="Primary" data-id="element-445">
      <div className="max-w-[1600px] mx-auto flex gap-1" data-id="element-446">
        {tabs.map(tab => {
        const active = page === tab.id;
        return <button key={tab.id} onClick={() => onChange(tab.id)} aria-current={active ? 'page' : undefined} className={`relative flex items-center gap-2 px-4 py-3 text-sm font-bold transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 rounded-t-md ${active ? 'text-[#0a1e5e]' : 'text-gray-500 hover:text-[#0a1e5e]'}`} data-id="element-447">
              {tab.icon}
              <span data-id="element-448">{tab.label}</span>
              {active && <span className="absolute left-2 right-2 -bottom-px h-0.5 bg-[#0a1e5e] rounded-full" data-id="element-449" />}
            </button>;
      })}
      </div>
    </nav>;
}